import { render, staticRenderFns } from "./KbvBudgetIndicator.vue?vue&type=template&id=d48e0078&scoped=true"
import script from "./KbvBudgetIndicator.vue?vue&type=script&lang=js"
export * from "./KbvBudgetIndicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d48e0078",
  null
  
)

export default component.exports